import type React from 'react'
import type { SimpleVehicleProps } from '../../../types/types'
import { FilterCarPark } from './FilterCarPark'
import { SearchCarPark } from './SearchCarPark'
import type { VehicleFilters } from '../../../helpers/filterVehicles'
import { mapCarStatus } from '../../../../../../../utils/helpers/helpers.cars'

export function CarParkSearchAndFilter({
  cars,
  search,
  setSearch,
  filters,
  setFilters,
  children,
}: {
  cars: SimpleVehicleProps[]
  search: string
  setSearch: (value: string) => void
  filters: VehicleFilters
  setFilters: React.Dispatch<React.SetStateAction<VehicleFilters>>
  children?: React.ReactNode
}) {
  function removeSingleFilter(filterKey: keyof VehicleFilters) {
    setFilters((prev) => ({ ...prev, [filterKey]: '' }))
  }

  function removeSingleItemInFilterKeyArray(filterKey: keyof VehicleFilters, item: string) {
    setFilters((prev) => {
      const filterValue = prev[filterKey]
      return {
        ...prev,
        [filterKey]: Array.isArray(filterValue) ? filterValue.filter((i) => i !== item) : [],
      }
    })
  }

  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between sm:gap-2">
      <div className="flex-1 flex flex-col gap-2 sm:flex-row sm:items-center">
        <SearchCarPark search={search} setSearch={setSearch} />
        <div className="flex flex-wrap gap-2">
          {Object.entries(filters).map(([key, value]) => {
            if (!value || value?.length === 0) return null
            const hasMultipleValues = Array.isArray(value) && value.length > 1
            if (hasMultipleValues) {
              return value.map((val) => (
                <FilterGroupPill
                  key={`${key}-${val}`}
                  label={`${val === '_ALL_' ? 'ALLE' : val}`}
                  onRemove={() => removeSingleItemInFilterKeyArray(key as keyof VehicleFilters, val)}
                />
              ))
            } else {
              return (
                <FilterGroupPill
                  key={key}
                  label={`${value === '_ALL_' ? 'ALLE' : value}`}
                  onRemove={() => {
                    removeSingleFilter(key as keyof VehicleFilters)
                  }}
                />
              )
            }
          })}
        </div>
      </div>
      <div className="flex items-center justify-between gap-4 sm:pt-4">
        <FilterCarPark filters={filters} setFilters={setFilters} cars={cars} />
        {children}
      </div>
    </div>
  )
}

export function FilterGroupPill({ label, onRemove }: { label: string; onRemove: () => void }) {
  return (
    <div className="flex relative items-center gap-2 bg-[#E5EEFF] border-[1px] border-[#B8C4E0] px-4 py-2 rounded-full">
      <span className="text-sm">{mapCarStatus(label)}</span>
      <button onClick={onRemove} className="text-blue-600">
        ×
      </button>
    </div>
  )
}
